/** @module Enums */ /** typedoc */
/**
 * Pending Item states for v2/library/
 */
var PendingItemStateEnum;
(function (PendingItemStateEnum) {
    PendingItemStateEnum["UploadingInProgress"] = "UploadingInProgress";
    PendingItemStateEnum["Processing"] = "Processing";
    PendingItemStateEnum["Available"] = "Available";
    PendingItemStateEnum["PreviewInProgress"] = "PreviewInProgress";
    PendingItemStateEnum["PreviewCompleted"] = "PreviewCompleted";
    PendingItemStateEnum["MasteringInProgress"] = "MasteringInProgress";
    PendingItemStateEnum["Error"] = "Error";
})(PendingItemStateEnum || (PendingItemStateEnum = {}));

export { PendingItemStateEnum };
